import { AxiosResponse } from 'axios';
import { ADDITIONAL_TAX_ORIGIN } from 'shared/constants/additionalTax';
import { apiV2 } from './http';

export function listTaxes(idi: string): Promise<AxiosResponse> {
  return apiV2.get(`installation/delivery/additional-tax/${idi}`);
}

export function updateTax(
  idi: number,
  yoogaAdditionalTaxId: number,
): Promise<AxiosResponse> {
  return apiV2.post(`installation/delivery/additional-tax/${idi}`, {
    yoogaAdditionalTaxId,
    origin: ADDITIONAL_TAX_ORIGIN.CUSTOMERS_PANEL,
  });
}
